<template lang="pug">
  .brands-page
    .main-container-wide
      Breadcrumbs(:links="[{name: 'Brands'}]")
      .brands-header
        h1.underline {{ __('Brands') }}
      loading(v-if="isLoading")
      .brands-content(v-if="!isLoading")
        rogue-link.item.brand-link(
          v-for="brand in data?.brands || []"
          :key="brand.url"
          :to="brand.url"
          :category="brand.categoryId"
        )
          StaticImage.brand-logo(
            :src="'media/catalog/category/'+brand.iconPath"
            :alt="brand.brandName"
            :width="140"
            :autoHeight="true"
            background="#ffffff"
            :height="100"
          )
      .brands-description
        | {{ __('From this page you can quickly navigate to specific product pages from all the major national and international brands we work with here at Rogue Fitness. This includes Westside Barbell, Dynamax, Reebok, York, Spud Inc., Oakley, and many more. Click any logo above to see our full catalog of offerings from that manufacturer.') }}
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useHead } from '@unhead/vue'
import { useRoute } from 'vue-router'
import { useRogue } from '@/js/services/Rogue'
import metadata from '@/js/helpers/metadata'

const rogue = useRogue()
const route = useRoute()

type Brand = {
  url: string,
  iconPath: string,
  brandName: string,
  categoryId: number,
}

useHead(metadata({ robots: 'all', title: rogue.__('Brands'), url: `${rogue.localizedBaseURL}${route.path}` }, rogue))

const isLoading = ref(true)
const data = ref<{brands: Brand[]}>()

onMounted(async () => {
  data.value = await rogue.fetch('/svc_content/catalog/product/brands')
  data.value?.brands.forEach((b:any) => {
    b.url = b.url[0] !== '/' ? `/${b.url}` : b.url
  })
  isLoading.value = false
})
</script>

<style lang="scss" scoped>
.brands-page {
  margin-top: $space-m;
}

.brand-logo :deep(img) {
  height: auto
}

.brands-content {
  display: grid;
  grid-gap: $space-xxs;
  grid-template-columns: repeat(auto-fill, 140px);
  grid-template-rows: repeat(auto-fill, 100px);
  justify-content: center;

  @include not-mobile {
    grid-gap: $space-m;
  }
}

.item {
  height: 100px;
  overflow: hidden;
}

.brands-description {
  margin-top: $space-m;
  padding-top: $space-s;
  border-top: $border-width-thin solid $color-gray-light;
  margin-bottom: $space-xl;
  color: $color-gray-dark;
  font-size: $size-xs;
  line-height: $line-height-l;
}
</style>
